import { Injectable } from '@angular/core';
import { Route, Router, RouterStateSnapshot } from '@angular/router';
import { LosAuthV2Service } from './los-auth-v2.service';

@Injectable({
  providedIn: 'root'
})
export class LosAuthGuardV2Service {

  constructor(
    private losAuthService: LosAuthV2Service,
    private router: Router
  ) { }

  canActivate(next: Route, state: RouterStateSnapshot): Promise<Boolean> {
    return new Promise(resolve => {
      return this.losAuthService.isLoggedSubscriber().subscribe(isLogged => {
        if (isLogged) {
          const hasPermission = this.losAuthService.hasMenuPermission(next.data.losAuthPermissions);
          resolve(hasPermission);
          if (!hasPermission) {
            this.router.navigate(['']);
          }
        } else {
          resolve(isLogged);
          location.href = next.data.urls.login;
        }
      });
    });
  }
}
